import React  from 'react';
import { useTranslation } from 'react-i18next';
import { closeMessage, requestReadMessage } from "../../../store/actionCreators/messages";
import {useDispatch} from "react-redux";
import { messageConverter } from '../../../helpers/Helper';

const emptyValue = { param1: '', param2: '', text: '' };

const PopUp = ({msg, accountId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const message = messageConverter(msg);
    const { param1, param2, text } = message && message.content || emptyValue;

    const close = () => {
        if( msg.status !== 'read' ) {
            dispatch(requestReadMessage({messageId: msg._id, accountId}));
        }
        dispatch(closeMessage(msg._id));
    };

    return (
        <div>
            {message && <div className={`notificationDialog dialog`}>
                <div className={`msgBody`}>
                    <div className={`msgTitle`}>
                        <span className="titleText">{t(message.header)}</span>
                        {/* need to check translation */}
                        <button className={`closeButton`} onClick={close}>
                            <i className=" fa close-icon fa-times " />
                        </button>
                    </div>
                    <span className={`msg-content`}>{t(text, { messageParam1: param1 || null, messageParam2: param2 || null })}</span>
                    <div className={`dialogConfirmBox`}>
                        <button className="primary" onClick={close}>{t('button.close')}</button>
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default PopUp;